var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormInput',_vm._g(_vm._b({ref:"field",staticClass:"place-autocomplete-input",on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"update:value":_vm.onValueChange}},'FormInput',_vm._props,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }